var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "cursor": "pointer",
      "padding": "5px"
    }
  }, [_c('button', {
    staticClass: "-btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.generatePDF('print')
      }
    }
  }, [_vm._v("Print "), _c('i', {
    staticClass: "fa fa-print"
  })]), _vm._v("  \n  "), _c('button', {
    staticClass: "-btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.generatePDF('download')
      }
    }
  }, [_vm._v("Download "), _c('i', {
    staticClass: "fa fa-file-pdf-o"
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "printdata"
    }
  }, [_c('h6', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "0px"
    }
  }, [_vm._v("Client Information")]), _vm._v(" "), _c('table', {
    staticClass: "tableExample",
    attrs: {
      "width": "100%",
      "data-pdfmake": "{\"widths\":[200,\"*\"],\"heights\":15}"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("KYC")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom": "none"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Company Short/ Display Name: " + _vm._s(_vm.clientname))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-top": "none"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Client System ID: " + _vm._s(_vm.clientid))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "vertical-align": "middle",
      "background-color": "#f68607",
      "color": "#fff"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("General Information")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom": "none"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Company Business/ Trade Name: " + _vm._s(_vm.generalInfo.CompanyName))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom": "none"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Client Website/Domain Name :  " + _vm._s(_vm.generalInfo.CompanyWebsite))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "vertical-align": "top",
      "border-right": "none",
      "border-top": "none"
    }
  }, [_vm._v("Business Address:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-left": "none",
      "border-top": "none"
    }
  }, [_c('table', {
    staticClass: "tableExample",
    attrs: {
      "width": "100%",
      "data-pdfmake": "{\"widths\":[\"*\"],\"heights\":15}"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "background-color": "#f2f2f2"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.generalInfoaddress1))]), _c('br'), _vm._v(" "), (_vm.generalInfoaddress2 != '') ? _c('span', [_vm._v(_vm._s(_vm.generalInfoaddress2))]) : _vm._e(), _c('br'), _vm._v(" "), _c('span', [_vm._v("State: " + _vm._s(_vm.stateName))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("City: " + _vm._s(_vm.cityName))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Pincode: " + _vm._s(_vm.generalInfo.ClientPinCode))])])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "vertical-align": "middle",
      "background-color": "#f68607",
      "color": "#fff"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Client SPOC Details")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-right": "none",
      "border-bottom": "none",
      "width": "150px"
    }
  }, [_vm._v("\n        SPOC Name: " + _vm._s(_vm.spocInfofirstName) + " " + _vm._s(_vm.spocInfolastName)), _c('br'), _vm._v("\n        Designation: " + _vm._s(_vm.spocInfo.designation) + "\n      ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-left": "none"
    }
  }, [_c('table', {
    staticClass: "tableExample",
    attrs: {
      "width": "100%",
      "data-pdfmake": "{\"widths\":[\"*\"],\"heights\":15}"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "background-color": "#f2f2f2"
    }
  }, [_c('span', [_vm._v("Email ID: " + _vm._s(_vm.spocInfo.Email))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Phone: " + _vm._s(_vm.spocInfo.phoneNumber) + " - " + _vm._s(_vm.spocInfo.extension))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Mobile: " + _vm._s(_vm.spocInfo.ContactNo))])])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "vertical-align": "middle",
      "background-color": "#f68607",
      "color": "#fff"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("XB SPOC Details")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("BD Name: " + _vm._s(_vm.bdlist))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("KAM Name: " + _vm._s(_vm.kamlist))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "vertical-align": "middle",
      "background-color": "#f68607",
      "color": "#fff"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Legal Information")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom": "none"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Company Registered Name: " + _vm._s(_vm.legelInfo.companyRegisteredName))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-top": "none",
      "border-bottom": "none",
      "vertical-align": "top",
      "border-right": "none"
    }
  }, [_vm._v("Registered Address:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-left": "none",
      "border-bottom": "none",
      "border-top": "none"
    }
  }, [_c('table', {
    staticClass: "tableExample",
    attrs: {
      "width": "100%",
      "data-pdfmake": "{\"widths\":[\"*\"],\"heights\":15}"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "background-color": "#f2f2f2"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.legelInfoaddress1))]), _c('br'), _vm._v(" "), (_vm.legelInfoaddress2 != '') ? _c('span', [_vm._v(_vm._s(_vm.legelInfoaddress2))]) : _vm._e(), _c('br'), _vm._v(" "), _c('span', [_vm._v("State: " + _vm._s(_vm.rStateName))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("City: " + _vm._s(_vm.rcityName))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Pincode: " + _vm._s(_vm.legelInfo.companyRegisteredPinCode))])])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "vertical-align": "top",
      "border-right": "none",
      "border-top": "none"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Legal Documents:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-left": "none",
      "border-bottom": "none",
      "border-top": "none"
    }
  }, [_c('table', {
    staticClass: "tableExample",
    attrs: {
      "width": "100%",
      "data-pdfmake": "{\"widths\":[\"*\"],\"heights\":15}"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "background-color": "#f2f2f2"
    }
  }, [_c('span', [_vm._v("Registration Number: " + _vm._s(_vm.legelInfo.registrationNumber))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("PAN: " + _vm._s(_vm.legelInfo.panNumber))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("TAN: " + _vm._s(_vm.legelInfo.tanNumber))])])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-left": "none",
      "border-top": "none"
    }
  }, [_c('table', {
    staticClass: "tableExample",
    attrs: {
      "width": "100%",
      "data-pdfmake": "{\"widths\":[150,\"*\"],\"heights\":15}"
    }
  }, [_c('tr', [_c('th', [_vm._v("GST Number")]), _vm._v(" "), _c('th', [_vm._v("State")])]), _vm._v(" "), _vm._l((_vm.gstData), function(data, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(data.RegistrationNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.RegistrationState))])])
  })], 2)])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "vertical-align": "middle",
      "background-color": "#f68607",
      "color": "#fff"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Bank Information")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-top": "none",
      "border-bottom": "none"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Beneficiary Name: " + _vm._s(_vm.bankInfo.beneficaryName))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-top": "none",
      "border-bottom": "none"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Bank Account Number: " + _vm._s(_vm.bankInfo.bankAccountNumber))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-top": "none",
      "border-bottom": "none",
      "border-right": "none"
    }
  }, [_vm._v("Bank Name: " + _vm._s(_vm.bankInfo.bankName))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-top": "none",
      "border-bottom": "none",
      "border-left": "none"
    }
  }, [_vm._v("IFSC/ RTGS: " + _vm._s(_vm.bankInfo.ClinetIFSCNumber))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-top": "none"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Bank Branch Name: " + _vm._s(_vm.bankInfo.bankBranch))])])]), _vm._v(" "), _c('h6', {
    staticClass: "pdf-pagebreak-before",
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "0px"
    }
  }, [_vm._v("Client Information")]), _vm._v(" "), _c('table', {
    staticClass: "tableExample",
    attrs: {
      "width": "100%",
      "data-pdfmake": "{\"widths\":[200,\"*\"],\"heights\":15}"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Other Information")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom": "none"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Company Short/ Display Name: " + _vm._s(_vm.clientname))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-top": "none"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Client System ID: " + _vm._s(_vm.ClientBusinessAccountId))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "vertical-align": "middle",
      "background-color": "#f68607",
      "color": "#fff"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Products")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom": "none"
    }
  }, [_vm._v("Product Categories: " + _vm._s(_vm.producInfo.productName))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-bottom": "none"
    }
  }, [_vm._v("Miscellaneous Description: " + _vm._s(_vm.producInfo.describeother))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-top": "none",
      "border-bottom": "none"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Nature of Goods: " + _vm._s(_vm.natureofgoods))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-top": "none"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Average Shipment Wt. (kg): " + _vm._s(_vm.producInfo.avgshipmentwt))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "vertical-align": "middle",
      "background-color": "#f68607",
      "color": "#fff"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Safety")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom": "none"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Damage Risk: " + _vm._s(_vm.safetyData.damageRisk))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-right": "none",
      "border-bottom": "none",
      "border-top": "none"
    }
  }, [_vm._v("Is product Liquid ?: " + _vm._s(_vm.safetyData.isliquid))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-left": "none",
      "border-bottom": "none",
      "border-top": "none"
    }
  }, [_vm._v("Flash Point (Celcius): " + _vm._s(_vm.safetyData.flashpoint))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-top": "none"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Is product fragile?: " + _vm._s(_vm.safetyData.isfragile))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "vertical-align": "middle",
      "background-color": "#f68607",
      "color": "#fff"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Security")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-right": "none"
    }
  }, [_vm._v("Product value per kg.: " + _vm._s(_vm.securityData.productvalue))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-left": "none"
    }
  }, [_vm._v("Risk of theft/ pilferage.: " + _vm._s(_vm.securityData.riskoftheft))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "vertical-align": "middle",
      "background-color": "#f68607",
      "color": "#fff"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Box Data")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom": "none"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Preferred UOM for box dimensions: " + _vm._s(_vm.preffereduomtext))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-top": "none"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('table', {
    staticClass: "headerrows",
    attrs: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Product")]), _vm._v(" "), _c('th', [_vm._v("Box Type")]), _vm._v(" "), _c('th', [_vm._v("Stacking Level")]), _vm._v(" "), _c('th', [_vm._v("Box Strength")]), _vm._v(" "), _c('th', [_vm._v("Dimensions (LxBxH)(cm.)")]), _vm._v(" "), _c('th', [_vm._v("Average Physical Wt. (kg.)")]), _vm._v(" "), _c('th', [_vm._v("HSN")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.boxDimData), function(data, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(data.productcategory))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.boxtype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.stackinglevel))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.boxstrength))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.dimension))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.avgphysicalwt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.hsn))])])
  }))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "vertical-align": "middle",
      "background-color": "#f68607",
      "color": "#fff"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Commercial Projections")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom": "none",
      "border-right": "none"
    }
  }, [_vm._v("Yearly sales projection (Tonnes)")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-bottom": "none",
      "border-left": "none"
    }
  }, [_vm._v("Expected Yield per kg: " + _vm._s(_vm.expectedyield))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-top": "none"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('table', {
    staticClass: "headerrows"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Month")]), _vm._v(" "), _c('th', [_vm._v("Year")]), _vm._v(" "), _c('th', [_vm._v("Projected Sales (Tonnes)")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.projectionsInfoData), function(data, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(data.month))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.year))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.sales))])])
  }))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "vertical-align": "middle",
      "background-color": "#f68607",
      "color": "#fff"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Manifest Data Upload Method")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Upload method: " + _vm._s(_vm.manifestmethod))])])]), _vm._v(" "), _c('h6', {
    staticClass: "pdf-pagebreak-before",
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "0px"
    }
  }, [_vm._v("Contract Information")]), _vm._v(" "), _c('table', {
    staticClass: "tableExample",
    attrs: {
      "width": "100%",
      "data-pdfmake": "{\"widths\":[300,\"*\"],\"heights\":15}"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Services")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n        Contract Name: " + _vm._s(_vm.contractname) + " "), _c('br'), _vm._v("\n        Contract ID: " + _vm._s(_vm.contractdisplayid) + " "), _c('br'), _vm._v("\n        Contract Effective Dates: "), _c('br'), _vm._v("\n        From Date " + _vm._s(_vm.contractstartdate) + " To Date " + _vm._s(_vm.contractenddate) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v("\n        Company Short/ Display Name: " + _vm._s(_vm.clientname) + " "), _c('br'), _vm._v("\n        Client System ID: " + _vm._s(_vm.ClientBusinessAccountId) + "\n      ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "vertical-align": "middle",
      "background-color": "#f68607",
      "color": "#fff"
    },
    attrs: {
      "colspan": "2",
      "height": "30"
    }
  }, [_vm._v("Contracted Services")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('table', {
    staticClass: "tableExample",
    attrs: {
      "width": "100%",
      "data-pdfmake": "{\"widths\":[50,80,\"*\"],\"heights\":15}"
    }
  }, [_c('tr', [_c('th', [_vm._v("TL Type")]), _vm._v(" "), _c('th', [_vm._v("Route Mode")]), _vm._v(" "), _c('th', [_vm._v("Booking Type")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "vertical-align": "middle"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("FTL")]), _vm._v(" "), _c('td', [_vm._v("Air")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.FTLAirArray))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Surface")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.FTLSurfaceArray))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "vertical-align": "middle"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("PTL")]), _vm._v(" "), _c('td', [_vm._v("Air")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.PTLAirArray))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Surface")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.PTLSurfaceArray))])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "vertical-align": "middle",
      "background-color": "#f68607",
      "color": "#fff"
    },
    attrs: {
      "colspan": "2",
      "height": "30"
    }
  }, [_vm._v("Service Levels")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Please check related service level CSV file")])])]), _vm._v(" "), _c('h6', {
    staticClass: "pdf-pagebreak-before",
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "0px"
    }
  }, [_vm._v("Contract Information")]), _vm._v(" "), _c('table', {
    staticClass: "tableExample",
    attrs: {
      "width": "100%",
      "data-pdfmake": "{\"widths\":[100,\"*\",\"auto\",\"auto\"],\"heights\":15}"
    }
  }, [_c('tr'), _c('tr', [_c('td', {
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v("Rates")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n        Contract Name: " + _vm._s(_vm.contractname) + " "), _c('br'), _vm._v("\n        Contract ID: " + _vm._s(_vm.contractdisplayid) + " "), _c('br'), _vm._v("\n        Contract Effective Dates: "), _c('br'), _vm._v("\n        From Date " + _vm._s(_vm.contractstartdate) + " To Date " + _vm._s(_vm.contractenddate) + "\n      ")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n        Company Short/ Display Name: " + _vm._s(_vm.clientname) + " "), _c('br'), _vm._v("\n        Client System ID: " + _vm._s(_vm.ClientBusinessAccountId) + "\n      ")]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, _vm._l((_vm.ratedata), function(data, index) {
    return _c('div', {
      key: index
    }, [_c('table', {
      staticClass: "tableExample",
      attrs: {
        "width": "100%",
        "data-pdfmake": "{\"widths\":[110,110,110,\"*\"],\"heights\":15}"
      }
    }, [_c('tr', [_c('th', [_vm._v("TL Type")]), _vm._v(" "), _c('th', [_vm._v("Route Mode")]), _vm._v(" "), _c('th', [_vm._v("Booking Type")]), _vm._v(" "), _c('th', [_vm._v("Rate Effective Dates")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(data.truckloadtype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.routemode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.bookingtype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.effectiveDateFrom) + " - " + _vm._s(data.effectiveDateTo))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Rate Basis")]), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "3"
      }
    }, [_vm._v(_vm._s((data.rateTemplateDetails.ratebasis == 1) ? "Weight (kg)" : (data.rateTemplateDetails.ratebasis == 2) ? "Quantity (Number of boxes)" : null))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "center",
        "vertical-align": "middle",
        "background-color": "#f68607",
        "color": "#fff"
      },
      attrs: {
        "colspan": "4",
        "height": "30"
      }
    }, [_vm._v("Weight/Box Definitions ")])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "border-bottom": "none",
        "border-right": "none"
      }
    }, [_vm._v("CFT Divisor: "), (_vm.preffereduom == 'cm') ? _c('span', [_vm._v("27000")]) : _vm._e(), (_vm.preffereduom == 'in') ? _c('span', [_vm._v("1728")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-bottom": "none",
        "border-right": "none",
        "border-left": "none"
      },
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("Preffered UOM for dimensions: " + _vm._s(_vm.preffereduomtext))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-bottom": "none",
        "border-left": "none"
      }
    }, [_vm._v("Agreed Wt. per CFT (kg): " + _vm._s(data.rateTemplateDetails.agreedwtcft))])]), _vm._v(" "), (data.rateTemplateDetails.ratebasis == 1) ? _c('tr', [_c('td', {
      staticStyle: {
        "border-bottom": "none",
        "border-top": "none"
      },
      attrs: {
        "colspan": "4"
      }
    }, [_vm._v("Minimum chargeable weight (kg): " + _vm._s(data.rateTemplateDetails.minimumchargeablewt))])]) : _vm._e(), _vm._v(" "), (data.rateTemplateDetails.ratebasis == 2) ? _c('tr', [_c('td', {
      staticStyle: {
        "border-bottom": "none",
        "border-top": "none"
      },
      attrs: {
        "colspan": "4"
      }
    }, [_vm._v("Minimum boxes : " + _vm._s(data.rateTemplateDetails.minimumboxes))])]) : _vm._e(), _vm._v(" "), (data.rateTemplateDetails.ratebasis == 1) ? _c('tr', [_c('td', {
      staticStyle: {
        "border-bottom": "none",
        "border-top": "none"
      },
      attrs: {
        "colspan": "4"
      }
    }, [_vm._v("Applicable weight (kg): " + _vm._s(data.applicableMinMax) + " OF (" + _vm._s(data.applicableWeight) + ")")])]) : _vm._e(), _vm._v(" "), (data.rateTemplateDetails.ratebasis == 1) ? _c('tr', [_c('td', {
      staticStyle: {
        "border-top": "none"
      },
      attrs: {
        "colspan": "4"
      }
    }, [_vm._v("Bill weight (kg): Rounding " + _vm._s(data.applicatbleRound) + " by a Rounding Factor(kg) of " + _vm._s(data.rateTemplateDetails.billwt.roundFactor) + " of (" + _vm._s(data.billWeight) + ")")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "center",
        "vertical-align": "middle",
        "background-color": "#f68607",
        "color": "#fff"
      },
      attrs: {
        "colspan": "4",
        "height": "30"
      }
    }, [_vm._v("Base Rate")])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "4"
      }
    }, [_vm._v(" Please check the related tariff card CSV file\n              ")])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "center",
        "vertical-align": "middle",
        "background-color": "#f68607",
        "color": "#fff"
      },
      attrs: {
        "colspan": "4",
        "height": "30"
      }
    }, [_vm._v("Minimum Charges")])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "4"
      }
    }, [_vm._v("\n                Minimum Charge Type : " + _vm._s((data.rateTemplateDetails.minimumchargetype == 1) ? "On basic freight" : "On net charges (before GST)")), _c('br'), _vm._v("\n                A = " + _vm._s((data.rateTemplateDetails.minimumchargetype == 1) ? "Base Rate x (Applicable Weight or Number of boxes)" : "Net charges")), _c('br'), _vm._v("\n                B = Minimum docket amount (INR) : " + _vm._s(data.rateTemplateDetails.minimumcharges) + "  "), _c('br'), _vm._v("\n                Minimum charges = Max (A,B)\n              ")])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "center",
        "vertical-align": "middle",
        "background-color": "#f68607",
        "color": "#fff"
      },
      attrs: {
        "colspan": "4",
        "height": "30"
      }
    }, [_vm._v("Freight Charges")])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "4"
      }
    }, [_vm._v("Freight Charges (INR): Base Rate x " + _vm._s(data.freightwttype))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "center",
        "vertical-align": "middle",
        "background-color": "#f68607",
        "color": "#fff"
      },
      attrs: {
        "colspan": "4",
        "height": "30"
      }
    }, [_vm._v("Insurance Charges")])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "4"
      }
    }, [_vm._v("Applicable charge : " + _vm._s((data.rateTemplateDetails.insuranceapplicablecharge == 1) ? "Fov" : (data.rateTemplateDetails.insuranceapplicablecharge == 2) ? "ROV" : "None"))])]), _vm._v(" "), (data.rateTemplateDetails.insuranceapplicablecharge != 0) ? _c('tr', [_c('td', {
      staticStyle: {
        "border-bottom": "none"
      },
      attrs: {
        "colspan": "4"
      }
    }, [_vm._v(_vm._s((data.rateTemplateDetails.insuranceapplicablecharge == 1) ? "FOV" : "ROV") + " Charge Type: " + _vm._s(data.fovchargetype))])]) : _vm._e(), _vm._v(" "), (data.fovchargetypevalue == 2 && data.rateTemplateDetails.insuranceapplicablecharge != 0) ? _c('tr', [_c('td', {
      staticStyle: {
        "border-bottom": "none"
      },
      attrs: {
        "colspan": "4"
      }
    }, [_vm._v(_vm._s((data.rateTemplateDetails.insuranceapplicablecharge == 1) ? "FOV" : "ROV") + " Charge Per Shipment (INR): " + _vm._s(data.insuranceRateData[0].fovvalue))])]) : _vm._e(), _vm._v(" "), (data.fovchargetypevalue == 1 && data.rateTemplateDetails.insuranceapplicablecharge != 0) ? _c('tr', [_c('td', {
      staticStyle: {
        "border-top": "none",
        "border-bottom": "none"
      },
      attrs: {
        "colspan": "4"
      }
    }, [_c('table', {
      staticClass: "tableExample",
      attrs: {
        "width": "100%",
        "data-pdfmake": "{\"widths\":[100,\"*\"],\"heights\":15}"
      }
    }, [_c('tr', [_c('td', [_vm._v(_vm._s((data.rateTemplateDetails.insuranceapplicablecharge == 1) ? "FOV" : "ROV") + " % Type")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.fovtype))])]), _vm._v(" "), (data.fovtype == 'Flat Rate') ? _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v(_vm._s((data.rateTemplateDetails.insuranceapplicablecharge == 1) ? "FOV" : "ROV") + " Rate (%): " + _vm._s(data.insuranceRateData[0].fovvalue) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (data.fovtype == 'Slab Based') ? _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('table', {
      staticClass: "tableExample",
      attrs: {
        "width": "100%",
        "data-pdfmake": "{\"widths\":[100,\"*\",\"auto\"],\"heights\":15}"
      }
    }, [_c('tr', [_c('td', {
      attrs: {
        "colspan": "3"
      }
    }, [_vm._v("Invoice Amount (INR)")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("From")]), _c('th', [_vm._v("To")]), _c('th', [_vm._v(_vm._s((data.rateTemplateDetails.insuranceapplicablecharge == 1) ? "FOV" : "ROV") + "%")])]), _vm._v(" "), _vm._l((data.insuranceRateData), function(data, index) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(data.fromvalue))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.tovalue))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.fovvalue))])])
    })], 2)])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (data.fovchargetypevalue == 1 && data.rateTemplateDetails.insuranceapplicablecharge != 0) ? _c('tr', [_c('td', {
      staticStyle: {
        "border-top": "none"
      },
      attrs: {
        "colspan": "4"
      }
    }, [_vm._v("\n                Limits (" + _vm._s((data.rateTemplateDetails.insuranceapplicablecharge == 1) ? "FOV" : "ROV") + " Charges) (INR):"), _c('br'), _vm._v("\n                Minimum: " + _vm._s(data.insuranceRateData[0].minfovvalue)), _c('br'), _vm._v("\n                Maximum: " + _vm._s(data.insuranceRateData[0].maxfovvalue) + "\n              ")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "center",
        "vertical-align": "middle",
        "background-color": "#f68607",
        "color": "#fff"
      },
      attrs: {
        "colspan": "4",
        "height": "30"
      }
    }, [_vm._v("Accessorial Charges")])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "border-bottom": "none"
      },
      attrs: {
        "colspan": "4"
      }
    }, [_c('table', {
      staticClass: "tableExample",
      attrs: {
        "width": "100%",
        "data-pdfmake": "{\"widths\":[150,\"*\"],\"heights\":15}"
      }
    }, [_c('tr', [_c('th', [_vm._v("Waybill Charges (INR)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.rateTemplateDetails.waybillcharge) + " per waybill")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "border-top": "none",
        "border-bottom": "none"
      },
      attrs: {
        "colspan": "4"
      }
    }, [_c('table', {
      staticClass: "tableExample",
      attrs: {
        "width": "100%",
        "data-pdfmake": "{\"widths\":[150,\"*\"],\"heights\":15}"
      }
    }, [_c('tr', [_c('th', [_vm._v("DC Charges(INR)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.rateTemplateDetails.dccharges) + " per waybill")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "border-top": "none",
        "border-bottom": "none"
      },
      attrs: {
        "colspan": "4"
      }
    }, [_c('table', {
      staticClass: "tableExample",
      attrs: {
        "width": "100%",
        "data-pdfmake": "{\"widths\":[300,\"*\"],\"heights\":15}"
      }
    }, [_c('tr', [_c('th', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("FTC/ To Pay charges")])]), _vm._v(" "), (data.fodchargetype == 1) ? _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("Per Docket : " + _vm._s(data.rateTemplateDetails.fodcharges) + " (INR)")])]) : _vm._e(), _vm._v(" "), (data.fodchargetype != 1) ? _c('tr', [_c('td', [_vm._v("% of freight charges : " + _vm._s(data.rateTemplateDetails.fodcharges) + " (%)")]), _vm._v(" "), _c('td', [_vm._v("Limits (FOD Charges) (INR):"), _c('br'), _vm._v("\n                      Minimum: " + _vm._s(data.rateTemplateDetails.fodmincharge)), _c('br'), _vm._v("\n                      Maximum: " + _vm._s(data.rateTemplateDetails.fodmaxcharge) + "\n                    ")])]) : _vm._e()])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "border-top": "none",
        "border-bottom": "none"
      },
      attrs: {
        "colspan": "4"
      }
    }, [_c('table', {
      staticClass: "tableExample",
      attrs: {
        "width": "100%",
        "data-pdfmake": "{\"widths\":[\"*\"],\"heights\":15}"
      }
    }, [_c('tr', [_c('th', [_vm._v("Fuel Surcharge")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Fuel Surcharge: Freight Charges x " + _vm._s(data.rateTemplateDetails.fuelsurchargepercent) + " (Surcharge %)/100")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "border-top": "none",
        "border-bottom": "none"
      },
      attrs: {
        "colspan": "4"
      }
    }, [_c('table', {
      staticClass: "tableExample",
      attrs: {
        "width": "100%",
        "data-pdfmake": "{\"widths\":[300,\"*\"],\"heights\":15}"
      }
    }, [_c('tr', [_c('th', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("Diesel Price Hike")])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "border-bottom": "none",
        "border-top": "none",
        "border-right": "none"
      }
    }, [_vm._v("Diesel Rate (INR/Ltr) on agreement date: " + _vm._s(data.rateTemplateDetails.fueldieselrate))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-bottom": "none",
        "border-top": "none",
        "border-left": "none"
      }
    }, [_vm._v("Diesel Price Hike By (INR/%): " + _vm._s(data.rateTemplateDetails.dieselhiketype))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "border-bottom": "none",
        "border-top": "none"
      },
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("Location Basis for Reference Diesel Price: " + _vm._s(data.rateTemplateDetails.dieselreflocation))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "border-bottom": "none",
        "border-top": "none",
        "border-right": "none"
      }
    }, [_vm._v("Increase in Fuel Rate by: " + _vm._s(data.rateTemplateDetails.fueluprevision))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-bottom": "none",
        "border-top": "none",
        "border-left": "none"
      }
    }, [_vm._v("Increase in Base Rate by: " + _vm._s(data.rateTemplateDetails.fueluprevisioncharge))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "border-top": "none",
        "border-right": "none"
      }
    }, [_vm._v("Decrease in Fuel Rate by: " + _vm._s(data.rateTemplateDetails.fueldownrevision))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-top": "none",
        "border-left": "none"
      }
    }, [_vm._v("Decrease in Base Rate by: " + _vm._s(data.rateTemplateDetails.fueldownrevisioncharge))])])])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "border-top": "none",
        "border-bottom": "none"
      },
      attrs: {
        "colspan": "4"
      }
    }, [_c('table', {
      staticClass: "tableExample",
      attrs: {
        "width": "100%",
        "data-pdfmake": "{\"widths\":[\"*\"],\"heights\":15}"
      }
    }, [_c('tr', [_c('th', [_vm._v("Delivery Attempts")])]), _vm._v(" "), _c('tr', [_c('td', [_c('table', {
      staticClass: "tableExample",
      attrs: {
        "width": "100%",
        "data-pdfmake": "{\"widths\":[300,\"*\"],\"heights\":15}"
      }
    }, [_c('tr', [_c('td', {
      staticStyle: {
        "border": "none"
      }
    }, [_vm._v("Free delivery attempts: " + _vm._s(data.rateTemplateDetails.deliveryattempt)), _c('br'), _vm._v("\n                           Minimum cost per paid attempt per docket (INR): " + _vm._s(data.rateTemplateDetails.deliveryattemptmincharge)), _c('br'), _vm._v("\n                           " + _vm._s(data.rateTemplateDetails.deliveryattempttype == 1 ? "Cost per paid attempt per kg (INR)" : "Cost per paid attempt per box (INR)") + ": " + _vm._s(data.rateTemplateDetails.costperdeliveryattempt) + "\n                         ")])])])])])])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "border-top": "none",
        "border-bottom": "none"
      },
      attrs: {
        "colspan": "4"
      }
    }, [_c('table', {
      staticClass: "tableExample",
      attrs: {
        "width": "100%",
        "data-pdfmake": "{\"widths\":[\"*\"],\"heights\":15}"
      }
    }, [_c('tr', [_c('th', [_vm._v("Storage Charges")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Applicable : " + _vm._s((data.rateTemplateDetails.demurragechargesapplicable == 1) ? "Yes" : "No"))])]), _vm._v(" "), (data.rateTemplateDetails.demurragechargesapplicable == 1) ? _c('tr', [_c('td', [_vm._v("\n                     Free storage days: " + _vm._s(data.rateTemplateDetails.demurragefreestoragedays)), _c('br'), _vm._v("\n                     Slot Days: " + _vm._s(data.rateTemplateDetails.demurrageslotsdays)), _c('br'), _vm._v("\n                     " + _vm._s(data.rateTemplateDetails.demurragecostperdaytype == 1 ? "Cost per kg per day (INR)" : data.rateTemplateDetails.demurragecostperdaytype == 2 ? "Cost per box per day (INR)" : "Cost per slot days (INR)") + ": " + _vm._s(data.rateTemplateDetails.demurragecostperday)), _c('br'), _vm._v("\n                     Cost per Docket per Day (INR): " + _vm._s(data.rateTemplateDetails.demurrageminimumcharges) + "\n                   ")])]) : _vm._e()])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "border-top": "none",
        "border-bottom": "none"
      },
      attrs: {
        "colspan": "4"
      }
    }, [_c('table', {
      staticClass: "tableExample",
      attrs: {
        "width": "100%",
        "data-pdfmake": "{\"widths\":[\"*\",\"*\"],\"heights\":15}"
      }
    }, [_c('tr', [_c('th', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("Appointment/ Different Vehicle Charges")])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("Applicable : " + _vm._s((data.rateTemplateDetails.vehicledeliveryapplicable == 1) ? "Yes" : "No"))])]), _vm._v(" "), (data.rateTemplateDetails.vehicledeliveryapplicable == 1) ? _c('tr', [_c('td', [_vm._v("\n                   Cost Type: " + _vm._s((data.rateTemplateDetails.vehicledeliverychargetype == 1) ? "Flat Rate" : (data.rateTemplateDetails.vehicledeliverychargetype == 2) ? "Slab Basis" : "Approval Basis") + "\n                   ")]), _vm._v(" "), _c('td', [_vm._v("\n                   Rate Basis: " + _vm._s((data.rateTemplateDetails.vehicledeliveryratebasis == 1) ? "Weight (kg)" : (data.rateTemplateDetails.vehicledeliverychargetype == 2) ? "Quantity (Number of boxes)" : null) + "\n                   ")])]) : _vm._e(), _vm._v(" "), (data.rateTemplateDetails.vehicledeliveryapplicable == 1 && data.rateTemplateDetails.vehicledeliverychargetype == 2) ? _c('tr', [_c('td', [_vm._v("\n                 Slab Type: " + _vm._s((data.rateTemplateDetails.vehicledeliveryslabtype == 1) ? "Weight (kg)" : (data.rateTemplateDetails.vehicledeliveryslabtype == 2) ? "Quantity (Number of boxes)" : null) + "\n                 ")]), _vm._v(" "), _c('td', [_vm._v("\n                 Slab Charge Type: " + _vm._s((data.rateTemplateDetails.vehicledeliveryslabchargetype == 1) ? "Incremental" : (data.rateTemplateDetails.vehicledeliveryslabchargetype == 2) ? "Absolute" : null) + "\n                 ")])]) : _vm._e(), _vm._v(" "), (data.rateTemplateDetails.vehicledeliveryapplicable == 1 && data.rateTemplateDetails.vehicledeliverychargetype == 2) ? _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('table', {
      staticClass: "tableExample",
      attrs: {
        "width": "100%"
      }
    }, [_c('tr', [_c('td', {
      attrs: {
        "colspan": "3"
      }
    }, [_vm._v(_vm._s((data.rateTemplateDetails.vehicledeliveryslabtype == 2) ? "Quantity (Number of boxes)" : "Weight (kg)"))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("From")]), _vm._v(" "), _c('th', [_vm._v("To")]), _vm._v(" "), _c('th', [_vm._v("Cost per Docket")])]), _vm._v(" "), _vm._l((data.vehicledelivery), function(vehicledata, index) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(vehicledata.fromvalue))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(vehicledata.tovalue))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(vehicledata.cost))])])
    })], 2)])]) : _vm._e(), _vm._v(" "), _vm._l((data.vehicledelivery), function(vehicledata, index) {
      return (data.rateTemplateDetails.vehicledeliveryapplicable == 1 && data.rateTemplateDetails.vehicledeliverychargetype == 1) ? _c('tr', [_c('td', {
        attrs: {
          "colspan": "2"
        }
      }, [_vm._v("Cost per kg (INR): " + _vm._s(vehicledata.cost))])]) : _vm._e()
    }), _vm._v(" "), (data.rateTemplateDetails.vehicledeliveryapplicable == 1) ? _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("Minimum charge per docket (INR): " + _vm._s(data.rateTemplateDetails.vehicledeliveryminimumchargeperdocket))])]) : _vm._e()], 2)])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "border-top": "none",
        "border-bottom": "none"
      },
      attrs: {
        "colspan": "4"
      }
    }, [_c('table', {
      staticClass: "tableExample",
      attrs: {
        "width": "100%",
        "data-pdfmake": "{\"widths\":[\"*\"],\"heights\":15}"
      }
    }, [_c('tr', [_c('th', [_vm._v("Mathadi/ Varai Charges")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Flat rate per box (MPS) (INR): " + _vm._s(data.rateTemplateDetails.mathadichargesperbox))])])])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "border-top": "none",
        "border-bottom": "none"
      },
      attrs: {
        "colspan": "4"
      }
    }, [_c('table', {
      staticClass: "tableExample",
      attrs: {
        "width": "100%",
        "data-pdfmake": "{\"widths\":[\"*\"],\"heights\":15}"
      }
    }, [_c('tr', [_c('th', [_vm._v("Handling Charges")])]), _vm._v(" "), _c('tr', [_c('td', [_c('table', {
      staticClass: "tableExample",
      attrs: {
        "width": "100%",
        "data-pdfmake": "{\"widths\":[\"*\",\"*\"],\"heights\":15}"
      }
    }, [_c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("Applicable : " + _vm._s((data.rateTemplateDetails.handlingchargesapplicable == 1) ? "Yes" : "No"))])]), _vm._v(" "), (data.rateTemplateDetails.handlingchargesapplicable == 1) ? _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("Max limits for no handling charges")])]) : _vm._e(), _vm._v(" "), (data.rateTemplateDetails.handlingchargesapplicable == 1) ? _c('tr', [_c('td', [_vm._v("Physical Weight (kg.) : " + _vm._s(data.rateTemplateDetails.handlingchargephysicalwt))]), _vm._v(" "), _c('td', [_vm._v("Dimensions (" + _vm._s(_vm.preffereduom) + ") (LxBxH) : "), (data.rateTemplateDetails.handlingchargedimesnion != null) ? _c('span', [_vm._v(_vm._s(data.rateTemplateDetails.handlingchargedimesnion.handlinglength) + "x" + _vm._s(data.rateTemplateDetails.handlingchargedimesnion.handlingbreadth) + "x" + _vm._s(data.rateTemplateDetails.handlingchargedimesnion.handlingHeight))]) : _vm._e()])]) : _vm._e()])])]), _vm._v(" "), (data.rateTemplateDetails.handlingchargesapplicable == 1) ? _c('tr', [_c('td', {
      staticStyle: {
        "border-top": "none"
      }
    }, [_c('table', {
      staticClass: "tableExample",
      attrs: {
        "width": "100%",
        "data-pdfmake": "{\"widths\":[\"*\",\"*\"],\"heights\":15}"
      }
    }, [_c('tr', [_c('td', [_vm._v("Overweight charges : " + _vm._s((data.rateTemplateDetails.handlingchargeoverwtchargetype == 1) ? "Flat Rate" : "Slab Rate"))]), _vm._v(" "), _c('td', [_vm._v("Over dimension charges")])]), _vm._v(" "), _c('tr', [(data.rateTemplateDetails.handlingchargeoverwtchargetype == 1) ? _c('td', [_vm._v("Per kg over max limit (INR) : " + _vm._s(data.overwtcharge[0].cost))]) : _vm._e(), _vm._v(" "), (data.rateTemplateDetails.handlingchargeoverwtchargetype == 2) ? _c('td', [_c('table', [_c('tr', [_c('th', [_vm._v("From")]), _vm._v(" "), _c('th', [_vm._v("To")]), _vm._v(" "), _c('th', [_vm._v(" Cost per kg (INR) (Per overweight MPS)")])]), _vm._v(" "), _vm._l((data.overwtcharge), function(overwtchargedata, index) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(overwtchargedata.fromvalue))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(overwtchargedata.tovalue))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(overwtchargedata.cost))])])
    }), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "3"
      }
    }, [_vm._v("Mechanical handling charges (forklift/crane) on actuals for weight above (kg) : " + _vm._s(data.rateTemplateDetails.mechanicalhandlingcharges))])])], 2)]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("Dedicated vehicle cost at agreed rate")])])])])]) : _vm._e()])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "border-top": "none",
        "border-bottom": "none"
      },
      attrs: {
        "colspan": "4"
      }
    }, [_c('table', {
      staticClass: "tableExample",
      attrs: {
        "width": "100%",
        "data-pdfmake": "{\"widths\":[\"*\"],\"heights\":15}"
      }
    }, [_c('tr', [_c('th', [_vm._v("Delivery above ground level")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Applicable : " + _vm._s((data.rateTemplateDetails.delievryabovegroundlevelapplicable == 1) ? "Yes" : "No"))])]), _vm._v(" "), (data.rateTemplateDetails.delievryabovegroundlevelapplicable == 1) ? _c('tr', [_c('td', [_vm._v("\n                     Max level above ground level for no extra charge: " + _vm._s((data.rateTemplateDetails.delievryabovegroundlevelmax == 0) ? 'Ground' : data.rateTemplateDetails.delievryabovegroundlevelmax)), _c('br'), _vm._v("\n                     Extra charges for delivery above max level defined: "), _c('br'), _vm._v("\n                     INR per kg per floor: " + _vm._s(data.rateTemplateDetails.delievryabovegroundlevelchargeperkg)), _c('br'), _vm._v("\n                     INR per box per floor: " + _vm._s(data.rateTemplateDetails.delievryabovegroundlevelchargeperdocket) + "\n                   ")])]) : _vm._e()])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "border-top": "none",
        "border-bottom": "none"
      },
      attrs: {
        "colspan": "4"
      }
    }, [_c('table', {
      staticClass: "tableExample",
      attrs: {
        "width": "100%",
        "data-pdfmake": "{\"widths\":[\"*\"],\"heights\":15}"
      }
    }, [_c('tr', [_c('th', [_vm._v("Green Tax (For Delhi Inbound shipments only)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                     Cost per kg (INR) : " + _vm._s(data.rateTemplateDetails.greentaxperkg) + "\n                   ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                     Cost per docket (INR) : " + _vm._s(data.rateTemplateDetails.greentaxperdocket) + "\n                   ")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "border-top": "none",
        "border-bottom": "none"
      },
      attrs: {
        "colspan": "4"
      }
    }, [_c('table', {
      staticClass: "tableExample",
      attrs: {
        "width": "100%",
        "data-pdfmake": "{\"widths\":[\"*\"],\"heights\":15}"
      }
    }, [_c('tr', [_c('th', [_vm._v("RTO Charges")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                     INR per rate basis (kg/box) in addition to contract rates applicable for destination : " + _vm._s(data.rateTemplateDetails.rtocharges) + "\n                   ")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "border-top": "none"
      },
      attrs: {
        "colspan": "4"
      }
    }, [_c('table', {
      staticClass: "tableExample",
      attrs: {
        "width": "100%",
        "data-pdfmake": "{\"widths\":[\"*\"],\"heights\":15}"
      }
    }, [_c('tr', [_c('th', [_vm._v("ODA Charges")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Applicable for Pickup: " + _vm._s((data.rateTemplateDetails.pickupodachargesapplicable == 1) ? "Yes" : "No"))])]), _vm._v(" "), (data.rateTemplateDetails.pickupodachargesapplicable == 1) ? _c('tr', [_c('td', [_vm._v("Rate Basis : " + _vm._s((data.rateTemplateDetails.pickupodachargeratebasis == 1) ? "Weight (kg)" : "Quantity (Number of boxes)"))])]) : _vm._e(), _vm._v(" "), (data.rateTemplateDetails.pickupodachargesapplicable == 1) ? _c('tr', [_c('td', [_vm._v("Rate Type : " + _vm._s((data.rateTemplateDetails.pickupodachargetype == 1) ? "Flat Rate" : "Slab Rate"))])]) : _vm._e(), _vm._v(" "), (data.rateTemplateDetails.pickupodachargetype == 1 && data.rateTemplateDetails.pickupodachargesapplicable == 1) ? _c('tr', [_c('td', [_c('table', {
      staticClass: "tableExample",
      attrs: {
        "width": "100%"
      }
    }, [_c('tr', [_c('th', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("Oda Charges 1")])]), _vm._v(" "), _vm._l((data.pickupodaRatesData[0]), function(odadata, index) {
      return _c('tr', [_c('td', [_vm._v("Additional rate per kg (INR): " + _vm._s(odadata['Rate Per Basis']))]), _vm._v(" "), _c('td', [_vm._v("Additional rate per docket (INR): " + _vm._s(odadata['Charges Per Docket']))])])
    })], 2)])]) : _vm._e(), _vm._v(" "), (data.rateTemplateDetails.pickupodachargetype == 1 && data.rateTemplateDetails.pickupodachargesapplicable == 1) ? _c('tr', [_c('td', [_c('table', {
      staticClass: "tableExample",
      attrs: {
        "width": "100%"
      }
    }, [_c('tr', [_c('th', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("Oda Charges 2")])]), _vm._v(" "), _vm._l((data.pickupodaRatesData[1]), function(odadata, index) {
      return _c('tr', [_c('td', [_vm._v("Additional rate per kg (INR): " + _vm._s(odadata['Rate Per Basis']))]), _vm._v(" "), _c('td', [_vm._v("Additional rate per docket (INR): " + _vm._s(odadata['Charges Per Docket']))])])
    })], 2)])]) : _vm._e(), _vm._v(" "), (data.rateTemplateDetails.pickupodachargetype == 1 && data.rateTemplateDetails.pickupodachargesapplicable == 1) ? _c('tr', [_c('td', [_c('table', {
      staticClass: "tableExample",
      attrs: {
        "width": "100%"
      }
    }, [_c('tr', [_c('th', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("Oda Charges 3")])]), _vm._v(" "), _vm._l((data.pickupodaRatesData[2]), function(odadata, index) {
      return _c('tr', [_c('td', [_vm._v("Additional rate per kg (INR): " + _vm._s(odadata['Rate Per Basis']))]), _vm._v(" "), _c('td', [_vm._v("Additional rate per docket (INR): " + _vm._s(odadata['Charges Per Docket']))])])
    })], 2)])]) : _vm._e(), _vm._v(" "), (data.rateTemplateDetails.pickupodachargetype == 1 && data.rateTemplateDetails.pickupodachargesapplicable == 1) ? _c('tr', [_c('td', [_c('table', {
      staticClass: "tableExample",
      attrs: {
        "width": "100%"
      }
    }, [_c('tr', [_c('th', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("Special Pin code charges")])]), _vm._v(" "), _vm._l((data.pickupodaRatesData[3]), function(odadata, index) {
      return _c('tr', [_c('td', [_vm._v("Additional rate per kg (INR): " + _vm._s(odadata['Rate Per Basis']))]), _vm._v(" "), _c('td', [_vm._v("Additional rate per docket (INR): " + _vm._s(odadata['Charges Per Docket']))])])
    })], 2)])]) : _vm._e(), _vm._v(" "), (data.pickupodaRatesData != '' && data.rateTemplateDetails.pickupodachargesapplicable == 1 && data.rateTemplateDetails.pickupodachargetype == 2) ? _c('tr', [_c('td', [_c('table', {
      staticClass: "tableExample",
      attrs: {
        "width": "100%"
      }
    }, [_c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("Oda Charges 1")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Slab Break")]), _vm._v(" "), _c('th', [_vm._v("Rate per basis")])]), _vm._v(" "), _vm._l((data.pickupodaRatesData[0]), function(odadata, index) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(odadata['Slab Break']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(odadata['Rate Per Basis']))])])
    })], 2)])]) : _vm._e(), _vm._v(" "), (data.pickupodaRatesData != '' && data.rateTemplateDetails.pickupodachargesapplicable == 1 && data.rateTemplateDetails.pickupodachargetype == 2) ? _c('tr', [_c('td', [_c('table', {
      staticClass: "tableExample",
      attrs: {
        "width": "100%"
      }
    }, [_c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("Oda Charges 2")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Slab Break")]), _vm._v(" "), _c('th', [_vm._v("Rate per basis")])]), _vm._v(" "), _vm._l((data.pickupodaRatesData[1]), function(odadata, index) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(odadata['Slab Break']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(odadata['Rate Per Basis']))])])
    })], 2)])]) : _vm._e(), _vm._v(" "), (data.pickupodaRatesData != '' && data.rateTemplateDetails.pickupodachargesapplicable == 1 && data.rateTemplateDetails.pickupodachargetype == 2) ? _c('tr', [_c('td', [_c('table', {
      staticClass: "tableExample",
      attrs: {
        "width": "100%"
      }
    }, [_c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("Oda Charges 3")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Slab Break")]), _vm._v(" "), _c('th', [_vm._v("Rate per basis")])]), _vm._v(" "), _vm._l((data.pickupodaRatesData[2]), function(odadata, index) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(odadata['Slab Break']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(odadata['Rate Per Basis']))])])
    })], 2)])]) : _vm._e(), _vm._v(" "), (data.pickupodaRatesData != '' && data.rateTemplateDetails.pickupodachargesapplicable == 1 && data.rateTemplateDetails.pickupodachargetype == 2) ? _c('tr', [_c('td', [_c('table', {
      staticClass: "tableExample",
      attrs: {
        "width": "100%"
      }
    }, [_c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("Special Pin code charges")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Slab Break")]), _vm._v(" "), _c('th', [_vm._v("Rate per basis")])]), _vm._v(" "), _vm._l((data.pickupodaRatesData[3]), function(odadata, index) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(odadata['Slab Break']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(odadata['Rate Per Basis']))])])
    })], 2)])]) : _vm._e(), _vm._v(" "), (data.pickupodaRatesData == '' && data.rateTemplateDetails.pickupodachargetype == 2) ? _c('tr', [_c('td')]) : _vm._e(), _vm._v(" "), (data.rateTemplateDetails.pickupodachargesapplicable == 1) ? _c('tr', [_c('td', [_vm._v("Minimum cost per docket : " + _vm._s(data.rateTemplateDetails.pickupodachargesminimum))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Applicable for Delivery : " + _vm._s((data.rateTemplateDetails.odachargesapplicable == 1) ? "Yes" : "No"))])]), _vm._v(" "), (data.rateTemplateDetails.odachargesapplicable == 1) ? _c('tr', [_c('td', [_vm._v("Rate Basis : " + _vm._s((data.rateTemplateDetails.odachargeratebasis == 1) ? "Weight (kg)" : "Quantity (Number of boxes)"))])]) : _vm._e(), _vm._v(" "), (data.rateTemplateDetails.odachargesapplicable == 1) ? _c('tr', [_c('td', [_vm._v("Rate Type : " + _vm._s((data.rateTemplateDetails.odachargetype == 1) ? "Flat Rate" : "Slab Rate"))])]) : _vm._e(), _vm._v(" "), (data.rateTemplateDetails.odachargetype == 1 && data.rateTemplateDetails.odachargesapplicable == 1) ? _c('tr', [_c('td', [_c('table', {
      staticClass: "tableExample",
      attrs: {
        "width": "100%"
      }
    }, [_c('tr', [_c('th', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("Oda Charges 1")])]), _vm._v(" "), _vm._l((data.odaRatesData[0]), function(odadata, index) {
      return _c('tr', [_c('td', [_vm._v("Additional rate per kg (INR): " + _vm._s(odadata['Rate Per Basis']))]), _vm._v(" "), _c('td', [_vm._v("Additional rate per docket (INR): " + _vm._s(odadata['Charges Per Docket']))])])
    })], 2)])]) : _vm._e(), _vm._v(" "), (data.rateTemplateDetails.odachargetype == 1 && data.rateTemplateDetails.odachargesapplicable == 1) ? _c('tr', [_c('td', [_c('table', {
      staticClass: "tableExample",
      attrs: {
        "width": "100%"
      }
    }, [_c('tr', [_c('th', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("Oda Charges 2")])]), _vm._v(" "), _vm._l((data.odaRatesData[1]), function(odadata, index) {
      return _c('tr', [_c('td', [_vm._v("Additional rate per kg (INR): " + _vm._s(odadata['Rate Per Basis']))]), _vm._v(" "), _c('td', [_vm._v("Additional rate per docket (INR): " + _vm._s(odadata['Charges Per Docket']))])])
    })], 2)])]) : _vm._e(), _vm._v(" "), (data.rateTemplateDetails.odachargetype == 1 && data.rateTemplateDetails.odachargesapplicable == 1) ? _c('tr', [_c('td', [_c('table', {
      staticClass: "tableExample",
      attrs: {
        "width": "100%"
      }
    }, [_c('tr', [_c('th', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("Oda Charges 3")])]), _vm._v(" "), _vm._l((data.odaRatesData[2]), function(odadata, index) {
      return _c('tr', [_c('td', [_vm._v("Additional rate per kg (INR): " + _vm._s(odadata['Rate Per Basis']))]), _vm._v(" "), _c('td', [_vm._v("Additional rate per docket (INR): " + _vm._s(odadata['Charges Per Docket']))])])
    })], 2)])]) : _vm._e(), _vm._v(" "), (data.rateTemplateDetails.odachargetype == 1 && data.rateTemplateDetails.odachargesapplicable == 1) ? _c('tr', [_c('td', [_c('table', {
      staticClass: "tableExample",
      attrs: {
        "width": "100%"
      }
    }, [_c('tr', [_c('th', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("Special Pin code charges")])]), _vm._v(" "), _vm._l((data.odaRatesData[3]), function(odadata, index) {
      return _c('tr', [_c('td', [_vm._v("Additional rate per kg (INR): " + _vm._s(odadata['Rate Per Basis']))]), _vm._v(" "), _c('td', [_vm._v("Additional rate per docket (INR): " + _vm._s(odadata['Charges Per Docket']))])])
    })], 2)])]) : _vm._e(), _vm._v(" "), (data.odaRatesData != '' && data.rateTemplateDetails.odachargesapplicable == 1 && data.rateTemplateDetails.odachargetype == 2) ? _c('tr', [_c('td', [_c('table', {
      staticClass: "tableExample",
      attrs: {
        "width": "100%"
      }
    }, [_c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("Oda Charges 1")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Slab Break")]), _vm._v(" "), _c('th', [_vm._v("Rate per basis")])]), _vm._v(" "), _vm._l((data.odaRatesData[0]), function(odadata, index) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(odadata['Slab Break']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(odadata['Rate Per Basis']))])])
    })], 2)])]) : _vm._e(), _vm._v(" "), (data.odaRatesData != '' && data.rateTemplateDetails.odachargesapplicable == 1 && data.rateTemplateDetails.odachargetype == 2) ? _c('tr', [_c('td', [_c('table', {
      staticClass: "tableExample",
      attrs: {
        "width": "100%"
      }
    }, [_c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("Oda Charges 2")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Slab Break")]), _vm._v(" "), _c('th', [_vm._v("Rate per basis")])]), _vm._v(" "), _vm._l((data.odaRatesData[1]), function(odadata, index) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(odadata['Slab Break']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(odadata['Rate Per Basis']))])])
    })], 2)])]) : _vm._e(), _vm._v(" "), (data.odaRatesData != '' && data.rateTemplateDetails.odachargesapplicable == 1 && data.rateTemplateDetails.odachargetype == 2) ? _c('tr', [_c('td', [_c('table', {
      staticClass: "tableExample",
      attrs: {
        "width": "100%"
      }
    }, [_c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("Oda Charges 3")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Slab Break")]), _vm._v(" "), _c('th', [_vm._v("Rate per basis")])]), _vm._v(" "), _vm._l((data.odaRatesData[2]), function(odadata, index) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(odadata['Slab Break']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(odadata['Rate Per Basis']))])])
    })], 2)])]) : _vm._e(), _vm._v(" "), (data.odaRatesData != '' && data.rateTemplateDetails.odachargesapplicable == 1 && data.rateTemplateDetails.odachargetype == 2) ? _c('tr', [_c('td', [_c('table', {
      staticClass: "tableExample",
      attrs: {
        "width": "100%"
      }
    }, [_c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("Special Pin code charges")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Slab Break")]), _vm._v(" "), _c('th', [_vm._v("Rate per basis")])]), _vm._v(" "), _vm._l((data.odaRatesData[3]), function(odadata, index) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(odadata['Slab Break']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(odadata['Rate Per Basis']))])])
    })], 2)])]) : _vm._e(), _vm._v(" "), (data.odaRatesData == '' && data.rateTemplateDetails.odachargetype == 2) ? _c('tr', [_c('td')]) : _vm._e(), _vm._v(" "), (data.rateTemplateDetails.odachargesapplicable == 1) ? _c('tr', [_c('td', [_vm._v("Minimum cost per docket : " + _vm._s(data.rateTemplateDetails.odachargesminimum))])]) : _vm._e()])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "border-top": "none",
        "border-bottom": "none"
      },
      attrs: {
        "colspan": "4"
      }
    }, [_c('table', {
      staticClass: "tableExample",
      attrs: {
        "width": "100%",
        "data-pdfmake": "{\"widths\":[\"*\"],\"heights\":15}"
      }
    }, [_c('tr', [_c('th', [_vm._v("Open Pickup/Delivery")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                     Applicable : " + _vm._s((data.rateTemplateDetails.openpickdeliveryapplicable == 1) ? "Yes" : "No") + "\n                   ")])]), _vm._v(" "), (data.rateTemplateDetails.openpickdeliveryapplicable == 1) ? _c('tr', [_c('td', [_vm._v("\n                     Rate per box per docket (INR) : " + _vm._s(data.rateTemplateDetails.openpickdeliverycharges)), _c('br'), _vm._v("\n                     Rate per Item within Child Shipment (INR) : " + _vm._s(data.rateTemplateDetails.openpickdeliveryrateperitem)), _c('br'), _vm._v("\n                     Minimum cost per docket : " + _vm._s(data.rateTemplateDetails.openpickdeliverychargesminimum) + "\n                   ")])]) : _vm._e()])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "border-top": "none",
        "border-bottom": "none"
      },
      attrs: {
        "colspan": "4"
      }
    }, [_c('table', {
      staticClass: "tableExample",
      attrs: {
        "width": "100%",
        "data-pdfmake": "{\"widths\":[\"*\"],\"heights\":15}"
      }
    }, [_c('tr', [_c('th', [_vm._v("Holiday Delivery")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                     Applicable : " + _vm._s((data.rateTemplateDetails.holidaydeliverychargeapplicable == 1) ? "Yes" : "No") + "\n                   ")])]), _vm._v(" "), (data.rateTemplateDetails.holidaydeliverychargeapplicable == 1) ? _c('tr', [_c('td', [_vm._v("\n                     " + _vm._s(data.rateTemplateDetails.holidaydeliverychargestype == 1 ? "Rate per kg per docket (INR)" : "Rate per box per docket (INR)") + " : " + _vm._s(data.rateTemplateDetails.holidaydeliverycharges)), _c('br'), _vm._v("\n                     Minimum cost per docket (INR): " + _vm._s(data.rateTemplateDetails.holidaydeliverymincharges) + "\n                   ")])]) : _vm._e()])])])])])
  }))])]), _vm._v(" "), _c('h6', {
    staticClass: "pdf-pagebreak-before",
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "0px"
    }
  }, [_vm._v("Contract Information")]), _vm._v(" "), _c('table', {
    staticClass: "tableExample",
    attrs: {
      "width": "100%",
      "data-pdfmake": "{\"widths\":[300,\"*\"],\"heights\":15}"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Terms and Conditions")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n        Contract Name: " + _vm._s(_vm.contractname) + " "), _c('br'), _vm._v("\n        Contract ID: " + _vm._s(_vm.contractdisplayid) + " "), _c('br'), _vm._v("\n        Contract Effective Dates: "), _c('br'), _vm._v("\n        From Date " + _vm._s(_vm.contractstartdate) + " To Date " + _vm._s(_vm.contractenddate) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v("\n        Company Short/ Display Name: " + _vm._s(_vm.clientname) + " "), _c('br'), _vm._v("\n        Client System ID: " + _vm._s(_vm.ClientBusinessAccountId) + "\n      ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "vertical-align": "middle",
      "background-color": "#f68607",
      "color": "#fff"
    },
    attrs: {
      "colspan": "2",
      "height": "30"
    }
  }, [_vm._v("Billing Terms")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('table', {
    staticClass: "tableExample",
    attrs: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "border": "none"
    }
  }, [_vm._v("Billing Cycle: " + _vm._s(_vm.billingCycle))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "none"
    }
  }, [_vm._v("POD hard copy required: " + _vm._s(_vm.pod))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "none"
    }
  }, [_vm._v("Last date for bill submission")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "none"
    }
  }, [_vm._v("POD hard copy charges: " + _vm._s(_vm.podCharge) + " INR per POD")])]), _vm._v(" "), (_vm.billingCycle != "Weekly") ? _c('tr', [_c('td', {
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('table', {
    staticClass: "tableExample",
    attrs: {
      "width": "100%"
    }
  }, [_c('tr', [_c('th', [_vm._v("Cycle Number")]), _c('th', [_vm._v("Day of the month (1-31)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1")]), _c('td', [_vm._v(_vm._s(_vm.date1))])]), _vm._v(" "), (_vm.billingCycle == 'Fortnightly') ? _c('tr', [_c('td', [_vm._v("2")]), _c('td', [_vm._v(_vm._s(_vm.date2))])]) : _vm._e()])])]) : _vm._e()])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "vertical-align": "middle",
      "background-color": "#f68607",
      "color": "#fff"
    },
    attrs: {
      "colspan": "2",
      "height": "30"
    }
  }, [_vm._v("Credit and Payment Terms")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('table', {
    staticClass: "tableExample",
    attrs: {
      "width": "100%",
      "data-pdfmake": "{\"widths\":[200,\"*\"],\"heights\":15}"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "border": "none"
    }
  }, [_vm._v("\n              Credit Period (Days): " + _vm._s(_vm.creditPeriod) + " "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("From date of submission of bill")]), _c('br'), _vm._v("\n              Credit Limit (INR): " + _vm._s(_vm.creditLimit)), _c('br'), _vm._v("\n              Credit Limit Alert %: " + _vm._s(_vm.creditAlert)), _c('br'), _vm._v("\n              Advance payment %: " + _vm._s(_vm.advancePayment) + "\n            ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "none"
    }
  }, [_vm._v("\n              Payment Mode: " + _vm._s(_vm.paymentmode) + " "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("In favour of ")]), _c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Busybees Logistics Solutions Pvt. Ltd.")]), _vm._v(".")])])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "vertical-align": "middle",
      "background-color": "#f68607",
      "color": "#fff"
    },
    attrs: {
      "colspan": "2",
      "height": "30"
    }
  }, [_vm._v("Other Terms and Conditions")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('table', {
    staticClass: "tableExample",
    attrs: {
      "width": "100%",
      "data-pdfmake": "{\"widths\":[150,\"*\"],\"heights\":15}"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Max liability")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-bottom": "none"
    }
  }, [_vm._v("Max liability amount (INR): " + _vm._s(_vm.liabilityAmount))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-top": "none"
    }
  }, [_vm._v("COF to be issued for lost, damaged or pilferage in case liability is more than maximum liability amount")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [_vm._v("COF (Certificate of Fact)")]), _vm._v(" "), _c('td', [_vm._v("Shipments will be accepted for transportation on the owner's risk basis.\n              The shipper is required to make his own transit insurance.\n              In the event of any unforseen circumstances of damage or loss,\n              the certificate of fact (COF) will be issued by Xpressbees.\n            ")])])])])])]), _vm._v(" "), _c('h6', {
    staticClass: "pdf-pagebreak-before",
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "0px"
    }
  }, [_vm._v("Contract Information")]), _vm._v(" "), _c('table', {
    staticClass: "tableExample",
    attrs: {
      "width": "100%",
      "data-pdfmake": "{\"widths\":[300,\"*\"],\"heights\":15}"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Annexures")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n        Contract Name: " + _vm._s(_vm.contractname) + " "), _c('br'), _vm._v("\n        Contract ID: " + _vm._s(_vm.contractdisplayid) + " "), _c('br'), _vm._v("\n        Contract Effective Dates: "), _c('br'), _vm._v("\n        From Date " + _vm._s(_vm.contractstartdate) + " To Date " + _vm._s(_vm.contractenddate) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v("\n        Company Short/ Display Name: " + _vm._s(_vm.clientname) + " "), _c('br'), _vm._v("\n        Client System ID: " + _vm._s(_vm.ClientBusinessAccountId) + "\n      ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n        Annexure Name:\n          "), _c('ol', _vm._l((_vm.AnnexureList), function(item) {
    return _c('li', [_vm._v(_vm._s(item.annexurename))])
  }))])])])])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ecf169e","hasScoped":true}!./src/modules/clientmanagement/views/ClientContractPDF/ClientContractPDF.component.html
// module id = 723
// module chunks = 3